import React from 'react';
import PropTypes from 'prop-types';
import {
  TabPane, Input, InputGroup, Row, Col
} from 'reactstrap';

import OptionList from '../metrics-list/OptionList';

const GoalInput = ({
  handleConfigDataChange, benchmark, name, metricName, title, goalError
}) => {
  const { goal } = benchmark;
  const onChange = (e) => {
    const { value } = e.target;
    handleConfigDataChange(metricName, name, value);
  };

  return (
    <div>
      <InputGroup className="config-container align-items-center">
        <div className="mr-3">{title}</div>
        <Input onChange={onChange} value={goal} className="option-list mr-3" />
      </InputGroup>
      <div className="error">{goalError}</div>
    </div>
  );
};

GoalInput.propTypes = {
  handleConfigDataChange: PropTypes.func.isRequired,
  benchmark: PropTypes.shape({
    goal: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
  }),
  name: PropTypes.string.isRequired,
  metricName: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  goalError: PropTypes.string
};

GoalInput.defaultProps = {
  goalError: undefined,
};

const TabContentList = ({
  item, name, component, goalError, handleConfigDataChange, benchmark, metricName
}) => (
    <TabPane key={item.name} tabId={name}>
      <Row>
        <Col sm="12">
          {component == 'input' ? (
            <GoalInput
              goalError={goalError}
              title={item.title}
              handleConfigDataChange={handleConfigDataChange}
              benchmark={benchmark}
              metricName={metricName}
              name={item.name}
            />
          ) : (
              <OptionList
                handleConfigDataChange={handleConfigDataChange}
                value={benchmark}
                title={item.title}
                metricName={metricName}
                name={item.name}
                options={item.options}
              />
            )}
        </Col>
      </Row>
    </TabPane>
  );

TabContentList.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    title: PropTypes.string
  }).isRequired,
  name: PropTypes.string.isRequired,
  component: PropTypes.string.isRequired,
  goalError: PropTypes.string,
  handleConfigDataChange: PropTypes.func.isRequired,
  benchmark: PropTypes.shape({
    goal: PropTypes.number
  }).isRequired,
  metricName: PropTypes.string.isRequired
};

TabContentList.defaultProps = {
  goalError: undefined,
};

export default TabContentList;



// WEBPACK FOOTER //
// ./src/components/dashboard/benchmark-tab/TabContentList.js